export default __webpack_public_path__ + "gateway.e3d6fcbf4a7ad4bd332d0bc44ede9948.svg";